<template>
  <div class="parameter-configuration container">
    <el-scrollbar wrap-class="m-scroll-wrap">
      <div class="content hi-df hi-jcc">
        <el-form
            :model="form"
            label-position="top"
            style="width: 380px; margin-top: 40px;"
            content-width="220px"
          >
          <h-page-group :title="$t('management.param.parameter_name')">
              <el-form-item
                :label="$t('management.param.is_enable_board')"
                required-right
              >
                <el-switch
                  v-model="form.enableDisplayboard"
                ></el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_china')"
                required-right
              >
                <el-switch
                  v-model="form.isChinaSpecial">
                </el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_show_message')"
                required-right
              >
                <el-switch v-model="form.showMessage" > </el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_show_todo')"
                required-right
              >
                <el-switch v-model="form.showTodo" > </el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_show_management_page')"
                required-right
              >
                <el-switch v-model="form.showManagePage"> </el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_support_refresh')"
                required-right
              >
                <el-switch v-model="form.useRefresh" > </el-switch>
              </el-form-item>
              <el-form-item
                :label="$t('management.param.is_neutral')"
                required-right
              >
                <el-switch v-model="form.isNeutral" > </el-switch>
              </el-form-item>
              <el-form-item style="margin-top: 40px">
                <el-button
                  type="primary"
                  @click="setConf"
                >{{
                  $t("common.setBtn_text")
                  }}</el-button>
              </el-form-item>
          </h-page-group>
          </el-form>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import API from 'api/api'
export default {
  name: 'parameter-configuration',
  data () {
    return {
      form:{
        enableDisplayboard:true,
        isChinaSpecial:true,
        showMessage:true,
        showTodo:true,
        showManagePage:true,
        useRefresh:true,
        isNeutral:true,
      }
    }
  },
  methods: {
    getConf(){
      API.common
      .getPortalParams()
      .then(res=>{
        for(let key in this.form){
          if(typeof res.data[key] === 'boolean'){
            this.form[key] = res.data[key]
          }
        }
      })
    },
    setConf(){
      const params ={
        ...this.form
      }
      API.common
      .setPortalParams(params)
      .then(res=>{
        this.$message.success(this.$t('management.param.set_success'))
      })
    }
  },
  created () {
    this.getConf()
  },
}
</script>
<style scoped lang="less" rel="stylesheet/less">
.parameter-configuration.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  position: relative;
  .content{

  }
  /deep/ .m-scroll-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

}
</style>
